import { createFileRoute } from '@tanstack/react-router'
import { TranscriptsPage } from '@/features/transcripts'

export const Route = createFileRoute('/_authenticated/ticketing/transcripts/')({
    component: TranscriptsPage,
});
